import Dropdown from 'components/form/fields/Dropdown/Dropdown';
import TextInput from 'components/form/fields/TextInput/TextInput';
import MultipleChoice from '../../../components/form/fields/MultiChoice';

export const formConfig = ({ userId, countries }: any) => {
  return {
    fields: [
      {
        InputProps: {
          disabled: true,
        },
        component: TextInput,
        name: 'name',
        title: 'Name',
      },
      {
        InputProps: {
          disabled: true,
        },
        component: TextInput,
        name: 'username',
        title: 'UserName',
      },
      {
        component: Dropdown,
        disabled: true,
        name: 'countryId',
        options: [
          {
            label: 'No',
            value: null,
          },
          ...countries,
        ],
        title: 'Country',
      },
      {
        component: Dropdown,
        name: 'type',
        options: [
          {
            label: 'User',
            value: 'user',
          },
          {
            label: 'Editor',
            value: 'editor',
          },
          {
            label: 'Admin',
            value: 'admin',
          },
          {
            label: 'SuperAdmin',
            value: 'superadmin',
          },
        ],
        title: 'Role',
      },
      {
        component: MultipleChoice,
        dictionary: 'countries',
        disabled: false,
        name: 'countriesToManage',
        title: 'Countries to manage',
      },
      {
        InputProps: {
          disabled: true,
        },
        component: TextInput,
        name: 'departmentName',
        title: 'Department',
      },
      {
        InputProps: {
          disabled: true,
        },
        component: TextInput,
        name: 'subDepartmentName',
        title: 'Subdepartment',
      },
      {
        InputProps: {
          disabled: true,
        },
        component: TextInput,
        name: 'seniorityName',
        title: 'Seniority',
      },
      {
        InputProps: {
          disabled: true,
        },
        component: TextInput,
        name: 'teamName',
        title: 'Team',
      },
      {
        InputProps: {
          disabled: true,
        },
        component: TextInput,
        name: 'titleName',
        title: 'Title',
      },
      {
        InputProps: {
          disabled: true,
        },
        component: TextInput,
        name: 'workPlaceName',
        title: 'Workplace',
      },
    ],
    title: userId ? 'Edit user' : 'Add user',
  };
};
